<div class="setting-container">
  <div class="setting-container-menu" [class.collapsed]="isMenuCollapsed">
    <button class="settings-collapse-btn" type="button" (click)="toggleMenuCollapse()" aria-label="Toggle settings menu">
      <svg class="settings-collapse-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <line x1="9" y1="3" x2="9" y2="21"/>
      </svg>
      <span *ngIf="!isMenuCollapsed">Menu</span>
    </button>
    <app-sub-menu
      [subTitle]="title"
      [subMenuInfo]="settingsMenus"
      [collapsed]="isMenuCollapsed"
    ></app-sub-menu>
  </div>
  <div class="setting-container-main">
    <div class="container">
      <button class="back-button" (click)="goBack()"><img src="../../../assets/back-arrow-icon.svg" alt="back arrow" class="icon"></button>
      <nav class="nav-pills">
        <div class="pill light clickable" [routerLink]="['/settings']">Settings</div>
        <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
          <span class="divider"><img src="../../../assets/caret-right.svg" alt="right caret" class="icon"></span>
          <div [ngClass]="last ? 'pill dark' : 'pill light clickable'" [routerLink]="last ? null : crumb.url">{{ formatLabel(crumb.label)  }}</div>
        </ng-container>
      </nav>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
